export enum PropertyType {
    UUID,
    TEXT,
    NAME,
    LINK,
    IMAGE,
    SELECTOR,
    PASSWORD,
    
    UNKNOWN
}